import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import theme from './theme/theme';
import AppLayout from './components/layout/AppLayout';

// Pages
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ProjectsPage from './pages/projects/ProjectsPage';
import ProjectFormPage from './pages/projects/ProjectFormPage';
import DailyStatusPage from './pages/status/DailyStatusPage';
import DefectsPage from './pages/defects/DefectsPage';
import ReportsPage from './pages/reports/ReportsPage';
import UsersPage from './pages/users/UsersPage';
import LeavePage from './pages/leaves/LeavePage';
import CategoriesPage from './pages/categories/CategoriesPage';

function PrivateRoute({ children, roles }) {
  const { user, loading, hasRole } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !hasRole(...roles)) return <Navigate to="/dashboard" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <LoginPage />} />

      <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/projects" element={<PrivateRoute><ProjectsPage /></PrivateRoute>} />
      <Route path="/projects/new" element={<PrivateRoute roles={['support_team', 'admin']}><ProjectFormPage /></PrivateRoute>} />
      <Route path="/projects/:id/edit" element={<PrivateRoute roles={['support_team', 'admin', 'qa_team', 'team_member']}><ProjectFormPage /></PrivateRoute>} />
      <Route path="/status" element={<PrivateRoute><DailyStatusPage /></PrivateRoute>} />
      <Route path="/defects" element={<PrivateRoute><DefectsPage /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
      <Route path="/users" element={<PrivateRoute roles={['support_team', 'admin']}><UsersPage /></PrivateRoute>} />
      <Route path="/leaves" element={<PrivateRoute><LeavePage /></PrivateRoute>} />
      <Route path="/categories" element={<PrivateRoute roles={['admin', 'support_team']}><CategoriesPage /></PrivateRoute>} />

      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}